__turbopack_context__.v({
  "buttons": "social-login-module__tk5VIW__buttons",
});
